class CxServiceUnavailableError extends Error {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(...params: any) {
    super(params);
  }
}

export {
  CxServiceUnavailableError
};